import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DrawerSelectEvent } from '@progress/kendo-angular-layout';
import { AuthService } from 'src/app/auth/services/auth.service';
import { SidebarClientLinks, SidebarNoAuthLinks, SidebarAdminLinks, SidebarStaffClientLinks } from '../../models/SidebarLink';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-dashboard-layout',
  templateUrl: './dashboard-layout.component.html',
  styleUrls: ['./dashboard-layout.component.scss'],
})
export class DashboardLayoutComponent implements OnInit {

  public items = SidebarClientLinks;
  public expandedIndices = [0];
  public expanded = true;

  @ViewChild('drawer') drawer: any;

  constructor(private auth: AuthService) {}

  ngOnInit(): void {}

  public get links() {
    if (this.auth.isLoggedIn$.getValue()) {
      if (this.auth.isMedikoUser) {
        return SidebarStaffClientLinks;
      }
      return SidebarClientLinks;
    } else {
      return SidebarNoAuthLinks;
    }
  }

  public isItemExpanded = (item: any): boolean => {
    return this.expandedIndices.indexOf(item.id) >= 0;
  };

  public onSelect(ev: DrawerSelectEvent) {
    const current = ev.item.id;
    if (this.expandedIndices.indexOf(current) >= 0) {
      this.expandedIndices = this.expandedIndices.filter(
        (id) => id !== current
      );
    } else {
      this.expandedIndices.push(current)
    }
  }

  onMenuClick() {
    this.drawer.toggle(!this.expanded);
  }
}
